import { auth, type SchemaResponse } from "@/modules/api"
import { GroupInbox, Message } from "@/modules/types"
import { PagingSchema } from "@/modules/types/common/schema"

export const getConversationsById = async (id: string) => {
  return await auth.get<SchemaResponse<GroupInbox>>(`conversations/${id}`)
}

export const getAllMessagesByCode = async (conversationCode?: string, page = 1, take = 20) => {
  return await auth.get<SchemaResponse<PagingSchema<GroupInbox>>>("conversations/get-all-message", {
    params: {
      page,
      take,
      sortBy: "createdAt",
      conversationCode,
      order: "DESC"
    }
  })
}

export const createMessagePresignedUrls = async (conversationCode: string, fileNames: string[]) => {
  return await auth.post<
    SchemaResponse<
      {
        fileName: string
        fileUrl: string
        originalName: string
        uploadUrl: string
      }[]
    >
  >("conversations/create-message-presigned-urls", {
    conversationCode,
    fileNames
  })
}

export const createMessage = async (body: {
  conversationCode: string
  content: string
  type: string
  attachmentUrl?: string
  userId?: number | string
  isSendNoti?: boolean
}) => {
  return await auth.post<SchemaResponse<Message>>("conversations/create-message", body)
}
